import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import {WebcamModule} from 'ngx-webcam';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from './components/header/header.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { InputComponent } from './components/input/input.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DynamicFieldDirective } from './directives/dynamic-field/dynamic-field.directive';
import { DateInputComponent } from './components/date-input/date-input.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { SelectComponent } from './components/select/select.component';
import { TitleComponent } from './components/title/title.component';
import { DropdownInfoComponent } from './components/dropdown-info/dropdown-info.component';
import { AdvancedCheckboxComponent } from './components/advanced-checkbox/advanced-checkbox.component';
import { BooleanSelectionComponent } from './components/boolean-selection/boolean-selection.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CurrencyFormatterDirective } from './directives/currency-formatter/currency-formatter.directive';
import { ButtonMenuHeaderComponent } from './components/button-menu-header/button-menu-header.component';
import { AdvancedCheckboxUserComponent } from './components/advanced-checkbox-user/advanced-checkbox-user.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateFilterPipe } from './pipes/date-filter.pipe';
import { CommaSeparatorDirective } from './directives/comma-separator/comma-separator.directive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoaderService } from '../core/services/internationalization/translate-loader.service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductPriceFormComponent } from './components/product-price-form/product-price-form.component';
import { ClientNotificationCardComponent } from './components/cards/client-notification-card/client-notification-card.component';
import { CoveragesDropDownsComponent } from './components/coverages-drop-downs/coverages-drop-downs.component';
import { CoveragePriceCardComponent } from './components/coverage-price-card/coverage-price-card.component';
import { ProductContractFormComponent } from './components/forms/product-contract-form/product-contract-form.component';
import { ClientContractFormComponent } from './components/forms/client-contract-form/client-contract-form.component';
import { VerticalStepperComponent } from './components/steppers/vertical-stepper/vertical-stepper.component';
import { PayContractFormComponent } from './components/forms/pay-contract-form/pay-contract-form.component';
import { GlobalDialogComponent } from './components/globaldialog/globaldialog.component';
import { FormatTimeMmSsPipe } from './pipes/format-time-mm-ss.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { ConsentsComponent } from './components/consents/consents.component';
import { PolicySumaryConsentComponent } from './components/consents/policy-sumary-consent/policy-sumary-consent.component';
import { BannerAlertComponent } from './components/banner-alert/banner-alert.component';
import { ErrorBlockingDialogComponent } from './components/error-blocking-dialog/error-blocking-dialog.component';

const SHARED_COMPONENTS = [
  HeaderComponent,
  DynamicFormComponent,
  InputComponent,
  DateInputComponent,
  CheckboxComponent,
  SelectComponent,
  TitleComponent,
  DropdownInfoComponent,
  AdvancedCheckboxComponent,
  AdvancedCheckboxUserComponent,
  BooleanSelectionComponent,
  ButtonMenuHeaderComponent,
  AutocompleteComponent,
  ProductPriceFormComponent,
  ClientNotificationCardComponent,
  CoveragesDropDownsComponent,
  CoveragePriceCardComponent,
  ProductContractFormComponent,
  ClientContractFormComponent,
  VerticalStepperComponent,
  FooterComponent,
  ConsentsComponent,
  PolicySumaryConsentComponent,
  ClientNotificationCardComponent,
  ProductContractFormComponent,
  ClientContractFormComponent,
  VerticalStepperComponent,
  PayContractFormComponent,
  GlobalDialogComponent,
  FormatTimeMmSsPipe,
  FooterComponent,
  BannerAlertComponent,
  ErrorBlockingDialogComponent,

];

const SHARED_DIRECTIVES = [
  DynamicFieldDirective,
  CurrencyFormatterDirective,
  CommaSeparatorDirective,
];

const SHARED_PIPES = [
  SafeHtmlPipe,
  DateFilterPipe
];

@NgModule({
  declarations: [
    SHARED_COMPONENTS,
    SHARED_DIRECTIVES,
    SHARED_PIPES,
  ],
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule,
    CarouselModule,
    ReactiveFormsModule,
    FormsModule,
    WebcamModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLoaderService,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    CommonModule,
    MaterialModule,
    SHARED_COMPONENTS,
    SHARED_DIRECTIVES,
    SHARED_PIPES
  ],
  providers: [
    //indicate the language of the calendar.
    { provide: MAT_DATE_LOCALE, useValue: environment.useValueCalendar},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS, useValue:  {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      }
  }
  ],
  entryComponents: [
    InputComponent,
  ]
  
})
export class SharedModule { }
